<template>
  <div>
    <div class="search_by_container">
      <search-companies></search-companies>
    </div>
    <datatable
      :is_createable="false"
      :show_delete="false"
      title="Offers"
      @thFilter="thFilter"
      @edit_click="editClick"
      @cv="clickedCV"
      @cv_other="clickedCvOther"
      @internal_notes="clickedInternalNotes"
      @star_statuses="starStatuses"
      @advanced_statuses="advancedStatuses"
      @related_positions="relatedPositions"
      @reject_offer="rejectOffer"
      @my_advanced_offers="myAdvancedOffers"
      @send_whatsapp="sendWhatsapp"
      @expose_offer="exposeOffer"
      @ai_evaluate="aiEvaluate"
      @send_history="sendHistory"
      :unique_buttons="unique_buttons"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import OffersHelper from '@/custom/classes/offers_helper.js'
import DataTable from '@/components/DataTable.vue'
import SearchCompanies from '@/components/SearchCompanies.vue'
import cvOtherMixin from '@/mixins/cvOtherMixin.js'
export default {
  name: 'admin-offers',
  mixins: [cvOtherMixin],
  data () {
    let filters_helper = new FiltersHelper()
    let offers_helper = new OffersHelper()
    return {
      filters_helper: filters_helper,
      offers_helper: offers_helper,
      fields: [
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'full_name',
          component_data_path: 'applicant',
          component: 'TableCellFullName'
        },
        {
          name: 'applicant_message',
          value: 'applicant_message',
          component_data_path: 'applicant',
          component: 'Message',
          additional_data: {
            endpoint: '/users/',
            headers: 'admin_headers',
            resource_type: 'Applicant'
          }
        },
        {
          name: 'company_name',
          component_data_path: 'position.company',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Company'
          }
        },
        {
          name: 'position_title',
          component_data_path: 'position',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Position'
          }
        },
        {
          name: 'position_message',
          component_data_path: 'position',
          component: 'Message',
          additional_data: {
            endpoint: '/positions/',
            headers: 'admin_headers',
            resource_type: 'Position'
          }
        },
        {
          name: 'offer_message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/offers/',
            headers: 'admin_headers',
            resource_type: 'Offer'
          }
        },
        {
          name: 'distance',
          value: 'distance',
          component: 'OfferDistance'
        },
        {
          name: 'status',
          value: 'status.name',
          component: 'OfferStatus'
        },
        {
          name: 'last_login',
          value: 'applicant.last_login',
          is_time: true
        },
        {
          name: 'sent_at',
          value: 'sent_at',
          is_time: true
        },
        {
          name: 'filters_message',
          value: 'filters_message'
        },
        {
          name: 'position_status',
          value: 'position.status'
        },
        {
          name: 'applicant_status',
          value: 'applicant.status'
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'score',
          value: 'score'
        },
        {
          name: 'score_info',
          value: 'score_info'
        },
        // The table renders LTR, so the last fields sit at the right edge.
        // Recruiters want the ids rightmost: applicant_id is the far-right column.
        {
          name: 'id',
          value: 'id',
          component_data_path: 'id',
          component: 'TableCellCopyId',
          additional_data: { title: 'העתק מזהה הצעה' }
        },
        {
          name: 'position_id',
          value: 'position.id',
          component_data_path: 'position.id',
          component: 'TableCellCopyId',
          additional_data: { title: 'העתק מזהה משרה' }
        },
        {
          name: 'applicant_id',
          value: 'applicant.id',
          component_data_path: 'applicant.id',
          component: 'TableCellCopyId',
          additional_data: { title: 'העתק מזהה מועמד' }
        }
      ],
      filters: [
        {
          type: 'modal',
          designator: 'applicant_status',
          options: [
            { text: 'completed', value: 'completed' },
            { text: 'vetted', value: 'vetted' },
            { text: 'unvetted', value: 'unvetted' },
            { text: 'irrelevant', value: 'irrelevant' }
          ]
        },
        {
          type: 'checkbox',
          designator: 'group_by_applicant',
          title: 'Group by applicant'
        },
        {
          type: 'checkbox',
          designator: 'group_by_position',
          title: 'Group by position'
        },
        {
          type: 'modal',
          designator: 'statuses',
          options: this.getFiltersOptions
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        },
        {
          type: 'single',
          designator: 'is_hot_positions',
          options: [
            {
              text: 'true',
              value: true
            },
            {
              text: 'false',
              value: false
            }
          ]
        },
        {
          type: 'modal',
          designator: 'one_position_job_titles',
          options: this.singleDropdownJobTitles,
          splitter: '|'
        },
        {
          type: 'single',
          designator: 'positions_status',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'standby',
              value: 'standby'
            },
            {
              text: 'expired',
              value: 'expired'
            }
          ]
        }
      ],
      th_filters: {},
      sorters: [
        {
          designator: '',
          value: ''
        },
        {
          designator: 'sent_at',
          value: '-sent_at'
        },
        {
          designator: 'applicant_submitted_at',
          value: '-applicant_submitted_at'
        },
        {
          designator: 'created_at',
          value: '-created_at'
        },
        {
          designator: 'active_at',
          value: '-active_at',
          custom_sort: true
        },
        {
          designator: 'updated_at',
          value: '-updated_at'
        },
        {
          designator: 'distance',
          value: 'distance'
        },
        {
          designator: 'position',
          value: '-position_id'
        },
        {
          designator: 'owner',
          value: 'owners',
          custom_sort: true
        },
        {
          designator: '+score',
          value: 'score'
        },
        {
          designator: 'score',
          value: '-score'
        }
      ],
      data: [],
      unique_buttons: [
        { component: 'ScoreThisPage', payload: { d: this.getQueryParams, c: this.getCounters, type: 'Admin', id: 1 } },
        { name: 'advanced_statuses', display_text: 'Advanced Statuses' },
        { name: 'my_advanced_offers', display_text: 'My Advanced Offers' }
      ],
      operations: [
        { component: 'Preview', additional_data: { resource_type: 'Offer' } },
        { name: 'CV' },
        { name: 'cv_other', title: 'CV Other' },
        { name: 'reject_offer', icon: '/black_x.png' },
        {
          component: 'AlertButton',
          additional_data: { resource_type: 'Offer' }
        },
        { name: 'send_whatsapp', title: 'Send Offer WA' },
        {
          component: 'PhoneCallButton',
          additional_data: { resource_type: 'Company' }
        },
        {
          component: 'BoosterButton',
          additional_data: { resource_type: 'Offer' }
        },
        { name: 'internal_notes', icon: '/note.png' },
        {
          component: 'CompanySuitcase',
          additional_data: { resource_type: 'Offer' }
        },
        { name: 'related_positions', icon: '/magic_wand.png' },
        {
          component: 'ButtonEvaluate',
          additional_data: { resource_type: 'Offer' }
        },
        { name: 'expose_offer', title: 'expose' },
        { name: 'ai_evaluate', title: 'AI' },
        { name: 'send_history', title: 'שליחות' }
      ],
      working_th_searches: ['full_name', 'company_name', 'position_title', 'owner']
    }
  },
  created: function () {
    this.init()
    this.fetchAll()
    this.watchTreeShaking(this.singleDropdownJobTitles, 'one_position_job_titles')
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('jobTitles', ['singleDropdownJobTitles']),
    ...mapGetters('offerStatuses', ['getFiltersOptions', 'getAdvancedStatuses', 'getStarStatuses'])
  },
  watch: {
    dropdownAdmins (oldValue, newValue) {
      this.watchTreeShaking(newValue, 'owner')
    },
    singleDropdownJobTitles (newValue) {
      this.watchTreeShaking(newValue, 'one_position_job_titles')
    },
    getFiltersOptions (newValue) {
      this.watchTreeShaking(newValue, 'statuses')
    }
  },
  methods: {
    init () {
      this.getOffers()
    },
    watchTreeShaking (newValue, designator) {
      this.filters.forEach(filter => {
        if (filter.designator == designator) {
          filter.options = newValue
        }
      })
    },
    sendWhatsapp (data) {
      this.create({
        designator: 'whatsapp-conversation-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: 'Conversation',
        props: {
          applicant: data.applicant,
          offer: data
        }
      })
    },
    getOffers () {
      this.$network_utils
        .getResourceOffers({
          display_all: true,
          resource_type: 'Applicant',
          resource_id: 1,
          sort: this.$route.query.sort || '-applicant_submitted_at',
          custom_sort: this.$route.query.custom_sort,
          current_admin: this.$utils.getOwner().name,
          per: 100,
          page: this.$route.query.page || 1,
          show_id: this.$route.query.show_id,
          company_id: this.$route.query.company_id,
          ...this.filters_helper.getServerCallFilters(this.filters),
          ...this.th_filters
        })
        .then(res => {
          const response = Array.isArray(res) ? res : [res]
          let data = []
          for (let i = 0; i < response.length; i++) {
            let offer = response[i]
            offer.full_name =
              offer.applicant.first_name + ' ' + offer.applicant.last_name
            data.push(offer)
          }
          this.data = data
        })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getOffers()
    },
    relatedPositions (data) {
      this.create({
        designator: 'related-positions-modal',
        component_name: 'RelatedPositions',
        position: data.position,
        applicant: data.applicant,
        modal_title: data.position.title + ' - ' + data.position.company.name + ' - Related Positions '
      })
    },
    rejectOffer (data) {
      this.offers_helper.rejectOffer(data)
    },
    starStatuses () {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, statuses: this.getStarStatuses } })
    },
    advancedStatuses () {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, statuses: this.getAdvancedStatuses } })
    },
    aiEvaluate (data) {
      this.create({
        designator: 'ai-evaluation-modal-' + data.id,
        component_name: 'AiEvaluationModal',
        data,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    clickedCV (data) {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-offers-form-modal', component_name: 'AdminOffersForm', data, modal_title: 'Edit Offer' })
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Offer', resource_id: data.id, modal_title: 'הערות פנימיות' })
    },
    myAdvancedOffers () {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, owner: this.$utils.getOwner().name, statuses: this.getAdvancedStatuses } })
    },
    getQueryParams () {
      return {
        display_all: true,
        resource_type: 'Applicant',
        resource_id: 1,
        sort: this.$route.query.sort || '-applicant_submitted_at',
        custom_sort: this.$route.query.custom_sort,
        current_admin: this.$utils.getOwner().name,
        per: 100,
        page: this.$route.query.page || 1,
        show_id: this.$route.query.show_id,
        company_id: this.$route.query.company_id,
        ...this.filters_helper.getServerCallFilters(this.filters),
        ...this.th_filters
      }
    },
    getCounters () {
      return this.data.length
    },
    async exposeOffer (data) {
      const companyId = data.position && data.position.company && data.position.company.id
      if (!companyId) {
        this.$utils.emit('show_toast', { text: 'לא נמצא מזהה חברה', type: 'error' })
        return
      }

      try {
        const employees = await this.$network_utils.getCompanyEmployees({ company_id: companyId })

        const hasActiveUser = employees && employees.some(function (emp) { return emp.user && emp.user.status === 'active' })

        if (!hasActiveUser) {
          this.$utils.emit('show_toast', { text: 'אין לחברה משתמש פעיל אנא מלא', type: 'error' })
          this.create({
            designator: 'company-employees-manager',
            component_name: 'CompanyEmployeesManager',
            modal_title: 'ניהול משתמשי חברה',
            company_id: companyId
          })
          return
        }

        this.create({
          designator: 'offer-exposure-preparation-modal',
          component_name: 'OfferExposurePreparationModal',
          modal_title: 'הכנה לחשיפת הצעה',
          modal_width: 900,
          props: {
            offer: data
          }
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error checking company active user:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בבדיקת משתמש פעיל לחברה', type: 'error' })
      }
    },
    sendHistory (data) {
      this.create({
        designator: 'cv_send_history',
        component_name: 'CvSendHistoryModal',
        modal_title: 'היסטוריית שליחות',
        modal_width: 900,
        is_center_modal: true,
        props: { offer: data }
      })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable,
    SearchCompanies
  }
}
</script>
